module.exports = __webpack_public_path__ + "static/media/lunar-logo@2x.98514ef0.png";